const formatDollars = (dollars) => {
  const _dollars = ([ ...dollars ]).reverse()
    .map((char, index) => (
      index % 3 === 2 ? ` ${char}` : char
    ))
    .reverse()
    .join('')

  return _dollars.replace(/^ /, '')
}

const formatPrice = (price, withRub = true, isCents = true) => {
  if (!price && price !== 0) {
    return '...'
  }

  if (isCents) {
    if (typeof price === 'number') {
      return formatPrice(price / 100, withRub, false)
    }
    else if (/\.|,/.test(price)) {
      return formatPrice(Number(price.replace(/\.|,/, '')), withRub, false)
    }
    else {
      return formatPrice(Number(price) / 100, withRub, false)
    }
  }

  const stringPrice = String(price).replace('.', ',')
  const dollars     = formatDollars(stringPrice.replace(/,.*/, ''))
  const cents       = /,/.test(stringPrice) ? stringPrice.replace(/.*,/, '') : '00'
  const postFix     = withRub ? ' руб.' : ''

  if (cents.length === 0) {
    return `${dollars},00${postFix}`
  }
  if (cents.length === 1) {
    return `${dollars},${cents}0${postFix}`
  }

  return `${dollars},${cents}${postFix}`
}


export default formatPrice